import React, { useContext } from "react";
import { AuthContext } from "../globalContext/auth/authProvider";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ element, allowedRoles = [] }) {
  const [authState] = useContext(AuthContext);

  if (!allowedRoles?.includes(authState?.currentRole?.id)) {
    return <Navigate to="/access-denied" />;
  }

  return element;
}

export default ProtectedRoute;
